
	export default {
		mixins: [],
		props: [],
		components: {},
		data: function () {
			return {
				experiences: [],
				standard: {},
				edit_product: false
			};
		},
		computed: {
			checkoutNav() {
				return this.$store.getters.getBasket;
			},

			nextButtonText() {
				return this.orderContainsPostFulfilment ||
					this.orderContainsEmailFulfilment
					? "Choose Delivery"
					: "Proceed to payment";
			},

			/**
			 * Returns whether the age has been verified for the order
			 * @return bool
			 */
			ageVerified(){
				return this.$store.getters.getAgeVerified;
			}
		},
		watch: {
			checkoutNav: function (newVal, oldVal) {
				this.updateNavigation();
			},
		},
		created: function () {
			this.updateNavigation();
			this.resetAgeVerification();
		},
		mounted: function () {
			if (!process.client) return false;
			var body = document.body; // Safari
			var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
			body.scrollTop = 0;
			html.scrollTop = 0;
		},
		methods: {
			// if the basket doesn't contain any requirement for delivery details (pay it forward) just go straight to the payment page
			navigateToNextPage() {
				// If there are age restricted items and the user hasn't verified their age, show the modal
				let age_restricted = this.basket.some(item => item.age_restricted);

				if(age_restricted && this.ageVerified !== true) {
					this.show("age_restricted");
				}
				else{
					if (
						this.orderContainsPostFulfilment ||
						this.orderContainsEmailFulfilment
					) {
						this.$router.push({
							name: "delivery",
							params: {
								navigation: false
							}
						});
					} else {
						this.$store.commit("persisted/CHECKOUT_STEP", 2);
						this.$router.push({ name: "payment" }); // full reload for payment CSP (checkout-flow-middleware)
					}
				}
			},

			updateNavigation() {
				this.$store.commit("persisted/CHECKOUT_STEP", 1);
			},

			/*
			 * Age restricted methods
			 */
			resetAgeVerification() {
				// Always reset the age verified state back to false
				this.$store.commit('persisted/SET_AGE_VERIFIED', false);
			},

			confirmAge() {
				// Set the age verified state to true
				this.$store.commit('persisted/SET_AGE_VERIFIED', true);
				this.navigateToNextPage();
			},

			hideAgeRestrictedModal() {
				this.hide("age_restricted");
			},
			/* */

			/**
			 * show or hide a modal
			 */
			show(modal) {
				this.$modal.show(modal);
			},
			hide(modal) {
				this.$modal.hide(modal);
			},
		},

        head() {
            return {
                title: this.$store.getters.getAccount.name + ' - Basket'
            }
        }
	};
